import { useState, useMemo, useCallback } from 'react';
import { VentaActividad } from '../lib/supabase';

interface UseLazyPedidosProps {
  pedidos: VentaActividad[];
  itemsPerPage?: number;
}

export const useLazyPedidos = ({ pedidos, itemsPerPage = 20 }: UseLazyPedidosProps) => {
  const [displayCount, setDisplayCount] = useState(itemsPerPage);

  const displayedPedidos = useMemo(() => {
    return pedidos.slice(0, displayCount);
  }, [pedidos, displayCount]);

  const hasMore = displayCount < pedidos.length;
  const remainingCount = pedidos.length - displayCount;

  const loadMore = useCallback(() => {
    setDisplayCount(prev => Math.min(prev + itemsPerPage, pedidos.length));
  }, [itemsPerPage, pedidos.length]);

  const reset = useCallback(() => {
    setDisplayCount(itemsPerPage);
  }, [itemsPerPage]);

  return {
    displayedPedidos,
    hasMore,
    remainingCount,
    loadMore,
    reset,
    totalCount: pedidos.length,
    displayCount
  };
};
